import api from './api';
export const WixService = {
    searchProducts(query, limit = 10) {
        return api.get('/api/wix/products', { params: { query, limit } });
    },
    searchOrders(email, limit = 10) {
        return api.get('/api/wix/orders', { params: { email, limit } });
    },
};
